import type { TranslationContent, Langs } from '@CS/components/TranslationProvider/types';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { Content } from '@CS/components/Form';
import { useTranslation } from '@CS/hooks';
import CSS from './InputField.module.css';
import type { ChangeEvent } from 'react';

type InputFieldProps = {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: Record<Langs, string>;
  register: UseFormRegisterReturn;
  onBlur?: () => void;
  disabled?: boolean;

  error?: boolean;
  value?: string;
  width?: number;
  last?: boolean;

  type?: string;
  name: string;
  min?: number;
  max?: number;
};

export const InputField = ({
  placeholder = { en: '', ar: '' },
  onBlur = () => void 0,
  disabled = false,

  error = false,
  type = 'text',
  last = false,
  width = 100,

  onChange,
  register,
  value,
  name,
  min,
  max
}: InputFieldProps) => {
  const Translations = Content as TranslationContent;
  const onInputChange = onChange ?? register.onChange;

  const fieldLabel = useTranslation(Translations[name]);
  const localizedPlaceholder = useTranslation(placeholder);
  const fieldError = useTranslation(Translations[`${name}Error`]);

  return (
    <div
      className={CSS.fieldContainer}
      style={{
        marginBottom: (last && '0px') || 'revert-layer',
        width: `${width}%`
      }}
    >
      <label className={CSS.fieldLabel} htmlFor={name}>
        {fieldLabel}
      </label>

      <input
        id={name}
        min={min}
        max={max}
        type={type}
        {...register}
        value={value}
        onBlur={onBlur}
        autoComplete="off"
        disabled={disabled}
        onChange={onInputChange}
        className={CSS.inputField}
        placeholder={localizedPlaceholder}
      />

      {error && <em className={CSS.fieldError}>{fieldError}</em>}
    </div>
  );
};
